import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`This is me!`}</p>
    </blockquote>
    <p>{`I love Computer Science. Artificial Intelligence is my passion. Very interested in UI/UX Design, and Web Development.
Penetration Testing and CTF are my newest hobbies. Been a guitarist since the 8th grade and been in love with music ever since.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The Dream`}</p>
    </blockquote>
    <p>{`I want to create a generalized AI that is better than humans in research and other intellectual enterprises.`}<br />{` In one word, Artificial Super Intelligence.`}</p>
    <blockquote>
      <p parentName="blockquote">{`My definition of AI`}</p>
    </blockquote>
    <p>{`This one's a bit odd but there's no real agreement on the definition of AI. So here's mine:`}</p>
    <blockquote><i>"An intelligent agent is one that can do things to which we would attribute intelligence if done by biological beings."</i></blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      